export default __webpack_public_path__ + "static/media/a_db_img.f73f2d51.svg";